import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/bootstrap.min.css";
import "./assets/css/index.scss";
import mixins from "./mixins";
import apolloClient, { SubscriptionClient } from "./plugins/apollo_client";
import card from "./components/ui/card";
import container from "./components/ui/container";
import Calender from "./components/ui/calender";
import currency from "./components/ui/currency";
import table from "./components/ui/table.vue";
import PopoverModel from "./components/ui/popover-model.vue";
import Modal from "./components/ui/modal.vue";
import Vue3Toasity, { toast } from "vue3-toastify";
import VueLazyLoad from "vue3-lazyload";
import DpTable from "./components/ui/table";
import VueSelect from "vue3-select2-component";
import filters from "./mixins/filters";
import device from "vue-device-detector";
import { Cropper } from "vue-advanced-cropper";
import VueEditor from "./components/ui/editor.vue";
import("fontisto/css/fontisto/fontisto.min.css");
import "vue3-toastify/dist/index.css";
import VueExcelXlsx from "vue-excel-xlsx";
import "vue-advanced-cropper/dist/style.css";
import "vue-advanced-cropper/dist/theme.compact.css";

store.$apolloClient = apolloClient;
store.$subscribeClient = SubscriptionClient;
store.$toaster = toast;

store.$graphError = (err) => {
  const message = err?.message?.replace("GraphQL error: ", "") || "Server Error";
  toast.error(message);
};

const app = createApp(App);

app.component("card", card);
app.component("container", container);
app.component("currency", currency);
app.component("VueSelect", VueSelect);
app.component("dp-table", table);
app.component("PopoverModel", PopoverModel);
app.component("Modal", Modal);
app.component("DpTable", DpTable);
app.component("DpCalender", Calender);
app.component("VueCropper", Cropper);
app.component("VueEditor", VueEditor);

app.use(VueExcelXlsx);
app.use(device);
app.use(VueLazyLoad);
/* app.use(Vue3Toasity, {
  autoClose: 3000,
  theme: "light",
  transition: "slide"
}); */

app.mixin(filters);

app.use(store).use(router).mixin(mixins).mount("#app");
